import React, { useState, useEffect, useRef, useMemo } from "react";
import "./trainTask.less";
//语言切换
import intl from "react-intl-universal";
import en_US from "@/locales/en_US/index.json";
import zh_CN from "@/locales/zh_CN/index.json";
import successImg from "@/assets/success.png";
import examImg from "@/assets/exam.png";
import practiceImg from "@/assets/practice.png";
import { cloneDeep } from "lodash";
import {
  Button,
  Col,
  message,
  Modal,
  Radio,
  Row,
  Segmented,
  Typography,
  Menu,
} from "antd";
import { ReadOutlined } from "@ant-design/icons";
import { useParams } from "react-router";
import { useLocation } from "react-router-dom";
import {
  limitTrainTask,
  saveFileProcess,
  savePracticePaper,
} from "../../../../services/train";
import { getUserInfoToLocal } from "../../../../utils/auth";
import Question from "../components/question";
import Document from "../components/document";
import { guid } from "../../../../utils/utils";
import Watermark from "../components/WaterMark/waterMark";
import {
  checkExamTask,
  toExam,
  toExamQuestion,
  redoTrainTaskQuestion,
} from "../../../../services/exam";
//qiankun
import microApp from "../../../../utils/qiankun.js";
const { Text } = Typography;

const locales = {
  en_US,
  zh_CN,
};

//培训任务
function Task(props) {
  const [dataInfo, setDataInfo] = useState();
  const [fileIndex, setFileIndex] = useState(0);
  const [previewFileList, setPreviewFileList] = useState([]);
  const [pracQuestionInfo, setPracQuestionInfo] = useState(undefined); //练习题目信息
  const [pageStatus, setPageStatus] = useState("file"); //当前培训界面状态类型：file:培训文档，practice：去练习，practiceResult：练习结果，trainResult：培训结果
  const [tabValue, setTabValue] = useState(1); //当前tab选项
  const [timeStamp, setTimeStamp] = useState(0);
  const [examListModal, setExamListModal] = useState(false); //关联考试内容弹窗
  const [examTipsModalVisable, setExamTipsModalVisable] = useState(false); // 考试前提示弹窗
  const [currentExamTaskId, setCurrentExamTaskId] = useState(undefined);
  const [examTaskData, setExamTaskData] = useState(undefined); //检查通过考试任务配置信息
  const [workTypeId, setWorkTypeId] = useState("");
  const [practiceId, setPracticeId] = useState(""); //当前练习id

  const params = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  //const anchorRef = useRef(null);
  useEffect(() => {
    intl
      .init({
        currentLocale: localStorage.getItem("language_type") || "zh_CN",
        locales,
      })
      .then(() => {});
    toExam(params.id).then((res) => {
      if (res && res.code === 0) {
        setDataInfo(res.data);
        let runObj = res.data.practices.find((ite) => ite.isRunning);
        if (runObj) {
          setPracticeId(runObj.id);
        } else {
          runObj = res.data.practices.find(
            (ite) => !ite.isRunning && !ite.isSubmit
          );
          if (runObj) {
            setPracticeId(runObj.id);
          } else {
            setPracticeId(res.data.practices[0].id);
          }
        }
        if (res.data.linkedCultivates && res.data.linkedCultivates.length > 0) {
          setCurrentExamTaskId(res.data.linkedCultivates[0].id);
        }
        //   if (anchorRef && anchorRef.current) {
        //     console.log("6666");
        //     anchorRef.current.onClick = () => {}; // 清空内部点击处理
        //   }
      }
    });
    window.addEventListener("beforeunload", () => savePracticeQueation());
  }, []);
  useEffect(() => {
    if (practiceId) {
      requestPracQueation(true, true);
    }
  }, [practiceId]);

  useEffect(() => {
    if (!pracQuestionInfo) {
      return;
    }
    if (
      workTypeId &&
      pracQuestionInfo.taskPacketId &&
      !["file"].includes(pageStatus)
    ) {
      if (microApp.isMounted) {
        const event = new CustomEvent("microChange", {
          detail: {
            workUnitId: pracQuestionInfo.taskPacketId,
            pageStatus,
            practiceId: practiceId,
            accuracy: pracQuestionInfo.accuracy,
          },
        });
        window.dispatchEvent(event);
      } else {
        microApp.load("#containerRef", {
          workUnitId: pracQuestionInfo.taskPacketId,
          pageStatus: pageStatus,
          practiceId: practiceId,
          accuracy: pracQuestionInfo.accuracy,
        });
      }
    } else {
      microApp.unload();
    }
  }, [workTypeId, pracQuestionInfo, pageStatus]);

  const loadVideoTime = (seconds) => {
    setTimeout(() => {
      const videoDom = document.getElementById("video");
      if (videoDom) {
        videoDom.currentTime = seconds;
      }
    }, 100);
  };

  //请求练习题目:
  const requestPracQueation = async (showFiles = true, refresh = true) => {
    let practice = cloneDeep(pracQuestionInfo);
    if (refresh) {
      await toExamQuestion({ practiceId: practiceId }).then((res) => {
        if (res && res.code === 0) {
          const obj = dataInfo.practices.find(
            (ite) => ite.id === res.practiceId
          );
          practice = {
            ...(obj || {}),
            ...res.data,
          };
          const keyObj = {
            0: "",
            1: intl.get("sentenceAccuracy"),
            2: intl.get("accurateWord"),
            3: intl.get("phoneticAccuracy"),
            4: intl.get("correctRhythm"),
          };
          if (practice.scoreType) {
            let passingScore = "";
            Object.keys(practice.scoreType).forEach((key) => {
              passingScore +=
                keyObj[key] +
                (practice.totalScore
                  ? intl.get("2c52244f-1f27-2b32-8890-4dc9e8648d0d")
                  : "") +
                (practice.totalScore
                  ? Math.round(
                      (practice.scoreType[key] * practice.totalScore) / 100
                    )
                  : practice.scoreType[key] + "%") +
                "；";
            });
            practice.passingScore = passingScore;
          }
          if (practice.accuracy) {
            let accuracyScore = [];
            Object.keys(practice.accuracy).forEach((key) => {
              accuracyScore.push(
                keyObj[key] +
                  (practice.totalScore
                    ? Math.round(
                        (practice.accuracy[key] * practice.totalScore) / 100
                      )
                    : practice.accuracy[key] + "%")
              );
            });
            practice.accuracyScore = accuracyScore;
          }
          setPracQuestionInfo(practice);
          setWorkTypeId(practice.workTypeId || "");
          if (practice.files && practice.files.length > 0) {
            //查看培训文档
            setPreviewFileList(practice.files.sort((a, b) => a.sort - b.sort));
          } else {
            setPreviewFileList([]);
          }
        }
      });
    }
    //1.获取培训任务数据：默认展示培训文档，若无培训文档则直接展示练习题目
    if (practice.files && practice.files.length > 0 && showFiles) {
      setPageStatus("file");
    } else {
      // 判断是否已提交，若已提交则展示联系结果页面，否则展示练习题目
      if (practice.isSubmit) {
        setPageStatus("practiceResult");
      } else {
        setTimeStamp(new Date().getTime());
        setPageStatus("practice");
        //定位到未做的第一道题目
        const undoQuestionList = practice.questions.filter(
          (item) => item.status === 0
        );
        if (undoQuestionList.length > 0) {
          const questionDom = document.getElementById(
            `question-${undoQuestionList[0].id}`
          );
          if (questionDom)
            questionDom.scrollIntoView({
              behavior: "smooth", // 平滑滚动
            });
        }
      }
    }
  };

  //保存
  const savePracticeQueation = (data1, unload = true, computeTime = true) => {
    const data = data1 || cloneDeep(pracQuestionInfo);
    if (
      !data ||
      pageStatus !== "practice" ||
      data.isSubmit ||
      params.status !== "train"
    ) {
      return true;
    }
    if (data && computeTime) {
      let submitTime = new Date().getTime();
      data.useTime = data.useTime + (submitTime - timeStamp) / 1000;
    }
    formatSaveQuestionAnswer(data);
    return savePracticePaper({
      id: data.historyId,
      isSubmit: 0,
      useTime: data.useTime,
      practicePaperList: data.questions,
    })
      .then((res) => {
        if (res && res.code === 0) {
          message.info(intl.get("7556b924-722b-2327-b5f8-41e6c8ce7f0a"));
          if (unload) {
            microApp.unload();
          }
          return true;
        }
        return false;
      })
      .catch(() => {
        return false;
      });
  };

  //题目数据发生变化 实时保存
  const changeQuestion = (index, operateType, key, value) => {
    const data = cloneDeep(pracQuestionInfo);
    if (operateType === "change") {
      data.questions[index][key] = value;
    }
    savePracticeQueation(data, false, false);
  };

  const loadPreviewFile = () => {
    const currentFile = previewFileList[fileIndex];
    if (pageStatus === "file") {
      if (currentFile) {
        if (currentFile?.type.indexOf("video") !== -1) {
          if (currentFile.watchProgress) {
            loadVideoTime(currentFile.watchProgress);
          }
          return (
            <video
              id="video"
              width="100%"
              style={{ maxHeight: "calc(100% - 120px)" }}
              controls
              controlsList="nodownload"
            >
              <source src={previewFileList[fileIndex]?.url} type="video/mp4" />
            </video>
          );
        } else if (currentFile?.type.indexOf("sheet") !== -1) {
          return (
            <iframe
              title="txtPreview"
              src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                previewFileList[fileIndex]?.url
              )}#page=${1}&toolbar=0`}
            ></iframe>
          );
        } else if (currentFile?.type.indexOf("audio") !== -1) {
          return (
            <div
              style={{
                width: "100%",
                height: "calc(100% - 120px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#fff",
              }}
            >
              <audio
                autoPlay={false}
                controls
                src={previewFileList[fileIndex]?.url}
                style={{ width: "90%" }}
              ></audio>
            </div>
          );
        } else if (currentFile?.type.indexOf("image") !== -1) {
          return (
            <img
              src={previewFileList[fileIndex]?.url}
              style={{
                width: "100%",
                height: "calc(100% - 120px)",
                objectFit: "contain",
              }}
            ></img>
          );
        } else {
          return (
            <iframe
              title="txtPreview"
              src={`${previewFileList[fileIndex]?.url}#page=${1}&toolbar=0`}
            ></iframe>
          );
        }
      }
    } else if (pageStatus === "practice" || pageStatus === "practiceResult") {
      //练习题目：考官无保存提交等按钮 //练习结果：判断是否关联考试且为考生
      return (
        <div
          id="containerRef"
          className={`questionContentWrap ${
            pageStatus === "practiceResult" ? "result" : ""
          }`}
        >
          {!workTypeId &&
            pracQuestionInfo.questions.map((question, i) => {
              if (question.selectQuestionOptionId) {
                question.options.map((o) => {
                  if (question.selectQuestionOptionId.indexOf(o.id) > -1) {
                    o.answer = true;
                  }
                });
              }
              return (
                <Question
                  key={`question-${question.questionId}`}
                  canEdit={false}
                  index={i}
                  data={question}
                  isOnlyShowError={tabValue === 2}
                  changeQuestion={changeQuestion}
                  status={pageStatus === "practice" ? "exam" : "examResult"}
                  hideDeleteBtn
                />
              );
            })}
        </div>
      );
    } else if (pageStatus === "trainResult") {
      //培训结果
      return (
        <div className="resultContent">
          <div className="center">
            <img className="tipIcon" src={successImg} />
            <div className="resultTips">
              {intl.get("afd5fa60-cc3d-243c-a2c2-4c1bdbbf78a5")}
            </div>
            {dataInfo?.linkedCultivates.length > 0 && (
              <Button type="primary" onClick={() => setExamListModal(true)}>
                {intl.get("30fce350-b554-22fe-921d-1dcbf6bb71d9")}
              </Button>
            )}
          </div>
        </div>
      );
    }
    return <></>;
  };

  const saveVideoFileProcess = () => {
    if (previewFileList[fileIndex].type.indexOf("video") !== -1) {
      const videoDom = document.getElementById("video");
      if (
        videoDom &&
        videoDom.currentTime < videoDom.duration &&
        params.status === "train"
      ) {
        saveFileProcess({
          key: `${params.id}_${getUserInfoToLocal().uid}_${
            previewFileList[fileIndex].id
          }`,
          time: videoDom.currentTime.toFixed(0),
        });
      }
    }
  };

  const handleTabChange = (value) => {
    setTabValue(value);
  };

  const handleBtnClick = (type) => {
    let index = fileIndex;
    if (type === "prev") {
      //如果已经点击了去练习或者在练习结果，培训结果页，或者完成培训页；则点击【上一步】按钮为返回培训文档最后一个
      if (pageStatus !== "file") {
        if (!workTypeId) {
          if (savePracticeQueation()) {
            setPageStatus("file");
            setFileIndex(index);
          }
        } else {
          setPageStatus("file");
          setFileIndex(index);
        }
      } else {
        saveVideoFileProcess();
        index -= 1;
        setFileIndex(index);
      }
    } else if (type === "next") {
      saveVideoFileProcess();
      index += 1;
      setFileIndex(index);
    }
  };

  // 去练习
  const handleToPractice = () => {
    saveVideoFileProcess();
    requestPracQueation(false, false);
  };

  // 去考试
  const handleToExam = () => {
    if (!currentExamTaskId) {
      setExamListModal(false);
      return;
    }
    //检查是否有剩余考试次数，是否超过到期时间等
    let mac = localStorage.getItem("dots-mac");
    if (!mac) {
      const macAdd = guid();
      localStorage.setItem("dots-mac", macAdd);
      mac = macAdd;
    }
    checkExamTask({ macAddress: mac, cultivateId: currentExamTaskId }).then(
      (res) => {
        if (res && res.code === 0) {
          setExamTaskData(res.data);
          setExamTipsModalVisable(true);
          setExamListModal(false);
        }
      }
    );
  };

  //跳转考试
  const redirectExam = () => {
    let str = "";
    const item = dataInfo?.linkedCultivates.find(
      (item) => item.id === currentExamTaskId
    );
    if (item) {
      str = item.workTypeId ? "?type=" + item.workTypeId : "";
    }
    window.open("/examTask/" + currentExamTaskId + "/exam" + str);
    setExamTipsModalVisable(false);
  };

  //跳转其他培训
  const redirectTrain = (trainTaskId) => {
    //检查是否有权限查看其他培训任务
    limitTrainTask(trainTaskId).then((res) => {
      if (res && res.code === 0) {
        window.open("/trainTask/" + trainTaskId + "/train");
        setExamListModal(false);
      }
    });
  };

  //重考确认弹窗
  const showReExamConfirm = () => {
    Modal.confirm({
      title: intl.get("Tips_f41babef-2238-24b3-8e39-bdb7bcb07d16"),
      content: (
        <p className="mT20">
          {intl.get("3c31bb5c-92f3-2e44-abca-af0ee740a40d")}
        </p>
      ),
      centered: true,
      okText: intl.get("ffab6c18-d433-2358-9e00-55e04781c4c6"),
      cancelText: intl.get("Cancel_51f2be22-0a99-2045-95f1-81feae4ea69d"),
      onOk: handleRePractice,
    });
  };

  // 重新练习
  const handleRePractice = () => {
    redoTrainTaskQuestion({ practiceId }).then((res) => {
      if (res && res.code === 0) {
        setTabValue(1);
        setPracQuestionInfo(res.data);
        setTimeStamp(new Date().getTime());
        setPageStatus("practice");
      }
    });
  };

  const formatSaveQuestionAnswer = (data) => {
    const data1 = data || cloneDeep(pracQuestionInfo);
    data1.questions.map((item) => {
      const selectAnswerList = [];
      item.options.filter((o) => {
        if (o.answer) {
          selectAnswerList.push(o.id);
        }
      });
      //本选项是正确答案，并且选中该选项
      item.selectQuestionOptionId = selectAnswerList.join(",");
    });
    setPracQuestionInfo(data1);
    return data1;
  };

  // 提交练习
  const [submitLoading, setSubmitLoading] = useState(false);
  const handleSubmitClick = async () => {
    const pracQuestionInfo = formatSaveQuestionAnswer();
    const undoQuestionList = [];
    pracQuestionInfo.questions.map((item, index) => {
      if (!item.selectQuestionOptionId) {
        undoQuestionList.push(index + 1);
      }
    });
    if (undoQuestionList.length > 0) {
      message.warn(
        intl.get("e0e7bd46-99b4-2b71-9989-2896b99519c7", {
          index: undoQuestionList.join(","),
        })
      );
      return;
    }
    //如果是嵌套的其他微服务，可能需要保存一下数据，比如TTS的当前数据
    if (
      window.__MICRO_PRE_SUNMIT__ &&
      typeof window.__MICRO_PRE_SUNMIT__ === "function"
    ) {
      const res = await window.__MICRO_PRE_SUNMIT__();
      if (!res) {
        return;
      }
    }
    let submitTime = new Date().getTime();
    const data = cloneDeep(pracQuestionInfo);
    data.useTime = data.useTime + (submitTime - timeStamp) / 1000;
    setPracQuestionInfo(data);
    setSubmitLoading(true);
    savePracticePaper({
      id: data.historyId,
      isSubmit: 1,
      useTime: data.useTime,
      practicePaperList: data.questions,
    })
      .then((res) => {
        if (res && res.code === 0) {
          const d = cloneDeep(dataInfo);
          const obj = d.practices.find((ite) => ite.id === data.practiceId);
          if (obj) {
            obj.isSubmit = true;
          }
          requestPracQueation(false, true);
        }
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  };
  const handleNext = () => {
    const index = dataInfo.practices.findIndex(
      (item) => item.id === practiceId
    );
    setPracticeId(dataInfo.practices[index + 1].id);
    const d = cloneDeep(dataInfo);
    d.practices[index + 1].isRunning = true;
    setDataInfo(d);
  };

  const handleCompleteClick = () => {
    saveVideoFileProcess();
    setPageStatus("trainResult");
  };

  //培训文档
  const [docVisible, setDocVisible] = useState(false);
  const toggleDocument = () => {
    setDocVisible(!docVisible);
  };

  // 根据状态获取对应图标和颜色
  const getStatusColor = (isRunning, isPassed, isSubmit) => {
    if (isPassed) {
      return "#008000"; // 绿色
    } else if (isSubmit) {
      return "#FF4D4F"; // 红色
    } else if (isRunning) {
      return "#1890FF"; // 蓝色
    } else {
      return "#BFBFBF"; // 灰色
    }
  };
  const handleClickAnchor = ({ key }) => {
    const obj = dataInfo.practices.find((item) => item.id === key);
    if (params.status === "preview") {
      setPracticeId(obj.id);
      return;
    }
    if (!obj || (!obj.isRunning && !obj.isSubmit)) {
      return;
    }
    if (savePracticeQueation()) {
      setPracticeId(obj.id);
      setPageStatus(obj.isSubmit ? "practiceResult" : "practice");
    }
  };

  return (
    <div className="boxContentWrap">
      <Watermark
        text={`${getUserInfoToLocal().name}${
          getUserInfoToLocal().uid
            ? getUserInfoToLocal().uid
            : getUserInfoToLocal().id
        }${intl.get("adeff155-6a7d-215c-bb8d-55298fca89d4")}`}
        key={timeStamp}
      />
      <Row className="headerWrap" justify={"space-between"}>
        <Col span="10">
          <Text ellipsis={{ tooltip: pracQuestionInfo?.name }}>
            {pracQuestionInfo?.name}{" "}
          </Text>
        </Col>
        {pageStatus.indexOf("practice") !== -1 && (
          <Col span="4">
            <span>{intl.get("8bd6825b-b3c3-26cd-9dac-5022716c4867")}</span>
          </Col>
        )}
        <Col span="10" className="alignEnd">
          {pageStatus === "practiceResult" && params.status === "train" && (
            <>
              {/* 去考试 */}
              {dataInfo.linkedCultivates.length > 0 && (
                <span
                  className="clickStyle mr10 fs14"
                  onClick={() => setExamListModal(true)}
                >
                  <img src={examImg} />
                  {intl.get("30fce350-b554-22fe-921d-1dcbf6bb71d9")}
                </span>
              )}
              {/* 重新练习 */}
              <span
                className="clickStyle mr10 fs14"
                onClick={showReExamConfirm}
              >
                <img src={practiceImg} />
                {intl.get("433a0f86-587b-24ad-9e03-1af10124d78c")}
              </span>
            </>
          )}
          {pageStatus === "practice" && params.status === "train" && (
            <>
              {/* 培训文档 */}
              {previewFileList.length > 0 && (
                <span className="clickStyle mr10 fs14" onClick={toggleDocument}>
                  <ReadOutlined />
                  {intl.get("training_document")}
                </span>
              )}
            </>
          )}
        </Col>
      </Row>
      <Menu
        selectedKeys={practiceId ? [practiceId] : []}
        items={(dataInfo?.practices || []).map((ite) => ({
          key: ite.id,

          label: (
            <div className="menu-item-content">
              <span
                className="menu-item-icon"
                style={{
                  borderColor: getStatusColor(
                    ite.isRunning,
                    ite.isPassed,
                    ite.isSubmit
                  ),
                }}
              />
              <span
                className="menu-item-label"
                style={{
                  color: getStatusColor(
                    ite.isRunning,
                    ite.isPassed,
                    ite.isSubmit
                  ),
                }}
              >
                {ite.name}
              </span>
            </div>
          ),

          disabled:
            !ite.isRunning && !ite.isSubmit && params.status !== "preview",
        }))}
        className="anchor-style-menu"
        onClick={handleClickAnchor}
      ></Menu>
      <div className="iframeWrap">
        {pageStatus === "practiceResult" && (
          <div className="pracResultContent">
            <div className="resultTitleWrap">
              {/* 得分 */}
              {pracQuestionInfo.totalScore > 0 && (
                <span className="itemWrap">
                  {intl.get("3fe01df5-dc92-22fc-9acd-82d6601ae672")}:{" "}
                  {(pracQuestionInfo.accuracyScore || []).map((ite) => (
                    <>
                      {ite}/
                      <span className="grayFont">
                        {pracQuestionInfo.totalScore}
                        {workTypeId ? "；" : ""}
                      </span>
                    </>
                  ))}
                </span>
              )}
              {workTypeId && !pracQuestionInfo.totalScore && (
                <span className="itemWrap">
                  {intl.get("AccuracyRate")}:{" "}
                  {(pracQuestionInfo.accuracyScore || []).map(
                    (ite) => ite + "；"
                  )}
                </span>
              )}
              {/* 及格线 */}
              {workTypeId && (
                <span className="itemWrap">
                  {intl.get("passing_score")}: {pracQuestionInfo.passingScore}
                </span>
              )}
              {/* 答对题数 */}
              <span className="itemWrap">
                {intl.get("ee6153bf-a153-250c-a75e-d5e5f6d7e938")}:{" "}
                {pracQuestionInfo.correctNum}/
                <span className="grayFont">{pracQuestionInfo.totalNum}</span>
              </span>
              {/* 用时 */}
              <span className="itemWrap">
                {intl.get("9bb6ca20-830e-230b-9992-9326ad980970", {
                  minute:
                    pracQuestionInfo.useTime < 60
                      ? 0
                      : Math.floor(pracQuestionInfo.useTime / 60),
                  second: (pracQuestionInfo.useTime % 60).toFixed(0),
                })}
              </span>
              {/* 练习次数 */}
              <span className="itemWrap">
                {intl.get("1c0220d2-b499-2c28-8d14-a3f3732d987f")}:{" "}
                {pracQuestionInfo.frequency}
              </span>
            </div>
            {/* 答案解析|错题 */}
            {!workTypeId && (
              <div className="tabWrap">
                <Segmented
                  options={[
                    {
                      label: (
                        <span>
                          {intl.get("2ac9ebd2-34d3-246b-ae56-691fc72352a6")}
                        </span>
                      ),
                      value: 1,
                    },
                    {
                      label: (
                        <span>
                          {intl.get("2fe854d4-a57b-27bb-a9d0-f120fa9bf1ce")}
                        </span>
                      ),
                      value: 2,
                    },
                  ]}
                  value={tabValue}
                  onChange={handleTabChange}
                />
              </div>
            )}
          </div>
        )}
        {pageStatus === "file" && previewFileList.length > 0 && (
          <span className="fileName">
            {fileIndex + 1}/{previewFileList.length}
            <span>{previewFileList[fileIndex]?.name}</span>
          </span>
        )}
        {loadPreviewFile()}
        <div className="btnWrap">
          {/* 上一步 */}
          {previewFileList.length > 0 &&
            (fileIndex !== 0 || pageStatus !== "file") && (
              <Button onClick={() => handleBtnClick("prev")}>
                {intl.get("39a30fd0-7135-264f-941d-adca9af6b14a")}
              </Button>
            )}
          {pageStatus === "file" && (
            <>
              {/* 下一步 */}
              {fileIndex !== previewFileList.length - 1 && (
                <Button type="primary" onClick={() => handleBtnClick("next")}>
                  {" "}
                  {intl.get("Next_7d758f4b-5509-2946-b7a8-d61384998d77")}
                </Button>
              )}
              {/* 去练习 */}
              {fileIndex === previewFileList.length - 1 &&
                pracQuestionInfo?.totalNum && (
                  <Button type="primary" onClick={handleToPractice}>
                    {intl.get("f4c69871-1c67-22cb-b430-794c85516142")}
                  </Button>
                )}
            </>
          )}
          {
            //提交练习按钮
            params.status !== "preview" && pageStatus === "practice" && (
              <Button
                type="primary"
                loading={submitLoading}
                onClick={handleSubmitClick}
              >
                {intl.get("Submit_b4c78c66-cc86-21f2-9581-710c4b1acf9b")}
              </Button>
            )
          }
          {
            //下一练习
            dataInfo &&
              practiceId &&
              practiceId !==
                dataInfo.practices[dataInfo.practices.length - 1].id &&
              pageStatus === "practiceResult" && (
                <Button
                  type="primary"
                  loading={submitLoading}
                  onClick={handleNext}
                >
                  {intl.get("Move_on_next_exercise")}
                </Button>
              )
          }
          {/* 完成:考生且：(文档状态最后一个文档且没关联练习) */}
          {params.status !== "preview" &&
            fileIndex === previewFileList.length - 1 &&
            pageStatus === "file" &&
            !pracQuestionInfo?.totalNum && (
              <Button type="primary" onClick={handleCompleteClick}>
                {intl.get("d2dd3861-a248-21ec-aaf9-108abe1df950")}
              </Button>
            )}
        </div>
      </div>
      {/* 考试任务选择弹窗 */}
      {examListModal && (
        <Modal
          title={intl.get("d8a40d0b-5019-2370-b7ca-a4ebcbac0b63")}
          open={examListModal}
          footer={null}
          onCancel={() => setExamListModal(false)}
        >
          <div>{intl.get("a908547d-78c8-2c99-a2cb-06cf6c9faada")}：</div>
          <Radio.Group
            className="mT10 width100"
            value={currentExamTaskId}
            onChange={(e) => setCurrentExamTaskId(e.target.value)}
          >
            {dataInfo?.linkedCultivates.map((exam) => {
              return (
                <Radio value={exam.id}>
                  <p>
                    {exam.name}（
                    {intl.get("fcffe4b7-3f76-20e2-9d3c-c7f3dfd81bf4")}：
                    {exam.skillsFieldName
                      ? exam.skillsFieldName
                      : intl.get("2c2ddaef-39e6-2158-a0b6-df3e2123ce42")}
                    ）
                  </p>
                  <p>
                    <div className="fl width25">
                      {intl.get("d7dfe457-d22a-2b00-b7c1-52b524bd550b")}：
                    </div>
                    <div className="fl width75">
                      {exam.cultivateList.length > 0
                        ? exam.cultivateList.map((c) => {
                            return (
                              <p
                                className="clickStyle"
                                onClick={() => redirectTrain(c.id)}
                              >
                                {c.name}
                              </p>
                            );
                          })
                        : intl.get("2c2ddaef-39e6-2158-a0b6-df3e2123ce42")}
                    </div>
                    <div className="clearFix"></div>
                  </p>
                </Radio>
              );
            })}
          </Radio.Group>
          <div className="alignCenter mT20">
            <Button type="primary" onClick={handleToExam}>
              {intl.get("ffab6c18-d433-2358-9e00-55e04781c4c6")}
            </Button>
          </div>
        </Modal>
      )}
      {/* 考试次数等提示 */}
      {examTipsModalVisable && (
        <Modal
          open={examTipsModalVisable}
          onOk={redirectExam}
          onCancel={() => setExamTipsModalVisable(false)}
          okText={intl.get("Confirm_fc189f71-934f-2caa-bd8f-29b9460afa19")}
          cancelText={intl.get("Cancel_51f2be22-0a99-2045-95f1-81feae4ea69d")}
        >
          <div className="comfirmWrap">
            {examTaskData.isSubmit ? (
              <div>{intl.get("f17cb7bf-357d-239b-8a5d-367f4cf1fb90")}</div>
            ) : (
              <>
                <div>
                  {intl.get("72ce5a88-fa2b-2600-832f-98307f8a4d8e", {
                    count: examTaskData.examRemainTimes,
                  })}
                  {intl.get("eaf218b7-0481-2ac2-ad8f-73c784eb4dfd", {
                    hour: examTaskData.examTimeH,
                    minute: examTaskData.examTimeM,
                  })}
                </div>
                {/*没有设置时间和次数时不展示警告提示 */}
                {(examTaskData.switchingTimes || examTaskData.timeoutTime) && (
                  <div className="warnTips">
                    {intl.get("8d8ccb8c-f131-215b-8054-084fb74e4a1a")}
                    {examTaskData.switchingTimes &&
                      intl.get("eb55eff7-baba-22e5-87b8-6b4f437fa33c", {
                        count: examTaskData.switchingTimes,
                      })}
                    {examTaskData.timeoutTime &&
                      intl.get("5a1415e7-9207-27f7-a621-65113cacce28", {
                        second: examTaskData.timeoutTime,
                      })}
                    {intl.get("5efb4498-bad0-28d1-ae9b-aab59ae5c35a")}
                  </div>
                )}
              </>
            )}
          </div>
        </Modal>
      )}
      {docVisible && (
        <Document docs={previewFileList} onClose={toggleDocument}></Document>
      )}
    </div>
  );
}
export default Task;
